<mat-card>
    <mat-card-header>
        <mat-card-title>
            <ng-container *ngIf="userUiType !== 4; else ambassadorTitle">Manage Relationships</ng-container>
            <ng-template #ambassadorTitle>Manage Your Choices</ng-template>
        </mat-card-title>
        <mat-card-subtitle>
            <ng-container *ngIf="userUiType !== 4; else ambassadorSubtitle">Add or remove destinations of type: {{ dependencyType }}</ng-container>
            <ng-template #ambassadorSubtitle>Search for places you love and add them to your profile.</ng-template>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="flex flex-col sm:flex-row sm:items-center gap-4 mb-6">
            <mat-form-field class="w-full flex-auto">
                <mat-label>
                    <ng-container *ngIf="userUiType !== 4; else ambassadorSearchLabel">Search for a destination to add</ng-container>
                    <ng-template #ambassadorSearchLabel>Find a place to recommend</ng-template>
                </mat-label>
                <input type="text"
                       [placeholder]="userUiType === 4 ? 'e.g., \'Paris\', \'The Louvre Museum\'' : 'Start typing a name...'"
                       aria-label="Find Destination"
                       (blur)="onBlur()"
                       (keyup)="onKeyupAutoSearch($event)"
                       matInput
                       [formControl]="parentControl"
                       [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete"
                                  requireSelection="true"
                                  (optionSelected)="optionSelected($event)"
                                  [displayWith]="displayFn"
                                  autoActiveFirstOption="true">
                    <mat-option *ngFor="let destination of filteredParents | async" [value]="destination">
                        {{ destination.ds_name }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="parentControl.hasError('notFound') && (parentControl.touched || parentControl.dirty)">
                    No valid destinations found for this search term.
                </mat-error>
            </mat-form-field>
            <button mat-raised-button
                    color="primary"
                    class="w-full sm:w-auto shrink-0"
                    [disabled]="!parentControl.value"
                    (click)="addParentToList()">
                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                <span class="ml-2">Add</span>
            </button>
        </div>

        <mat-divider class="mb-6"></mat-divider>

        <mat-form-field class="w-full">
            <mat-label>
                <ng-container *ngIf="userUiType !== 4; else ambassadorFilterLabel">Filter added destinations</ng-container>
                <ng-template #ambassadorFilterLabel>Search your choices</ng-template>
            </mat-label>
            <mat-icon matPrefix [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
            <input matInput
                   [placeholder]="userUiType === 4 ? 'Search your recommendations...' : 'Search by name'"
                   [formControl]="inputInternalSearchControl"
                   (keyup)="searchParentList()">
        </mat-form-field>

        <div class="flex flex-wrap gap-2 mb-4" *ngIf="destinationTypes.length > 1">
            <button mat-stroked-button
                    (click)="setDestinationTypeFilter(null)"
                    [color]="!activeDestinationTypeFilter ? 'primary' : 'basic'">
                All
            </button>
            <button mat-stroked-button
                    *ngFor="let type of destinationTypes"
                    (click)="setDestinationTypeFilter(type)"
                    [color]="activeDestinationTypeFilter === type ? 'primary' : 'basic'">
                {{ type }}
            </button>
        </div>

        <div class="border rounded-md overflow-hidden dark:border-gray-700">
            <mat-list role="list">
                <ng-container *ngIf="filteredParentList.length > 0; else noDestinations">
                    <ng-container *ngFor="let parentElement of filteredParentList; let last = last">
                        <mat-list-item role="listitem">
                            <mat-icon matListItemAvatar [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                            <div matListItemTitle>{{ parentElement.ds_label }}</div>
                            <div matListItemLine>{{ parentElement.ds_destinationtype }}</div>
                            <button mat-icon-button
                                    matListItemMeta
                                    [matTooltip]="userUiType === 4 ? 'Remove pick' : 'Remove Destination'"
                                    (click)="deleteParent(parentElement.id_destinationdependency)">
                                <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                            </button>
                        </mat-list-item>
                        <mat-divider *ngIf="!last"></mat-divider>
                    </ng-container>
                </ng-container>
            </mat-list>
        </div>

        <ng-template #noDestinations>
            <div class="flex flex-col items-center justify-center p-8 text-gray-500 text-center">
                <mat-icon class="icon-size-12" [svgIcon]="userUiType === 4 ? 'heroicons_outline:star' : 'heroicons_outline:link'"></mat-icon>
                <p class="mt-4 font-medium">
                    <ng-container *ngIf="userUiType !== 4; else noPicks">No relationships assigned</ng-container>
                    <ng-template #noPicks>You haven't added any choices yet</ng-template>
                </p>
                <p class="text-sm">
                    <ng-container *ngIf="userUiType !== 4; else noPicksHelp">Use the search bar above to find and add destinations.</ng-container>
                    <ng-template #noPicksHelp>Use the search bar above to find and recommend your choices.</ng-template>
                </p>
            </div>
        </ng-template>
    </mat-card-content>
</mat-card>
